class epg_event {
  constructor(start = 0, end = 0, title = "", description = "", cover = "") {
    this.start = start;
    this.end = end;
    this.title = title;
    this.description = description;
    this.cover = cover;
  }
}

export default epg_event;
